import { Map } from 'immutable';

import { getInventoryOperationValue } from '../../../product/getOperationValue';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { FAIRE } from '../../../../constants/channels';

export function availability({ preview }) {
  const payload = [];

  if (preview.hasIn([ATTRIBUTE.PREORDER, ATTRIBUTE.PREORDER])) {
    payload.push(
      Map({
        type: OPERATIONS[FAIRE].PREORDER.SET,
        value: !!preview.getIn([ATTRIBUTE.PREORDER, ATTRIBUTE.PREORDER]),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.PREORDER, ATTRIBUTE.KEEP_ACTIVE])) {
    payload.push(
      Map({
        type: OPERATIONS[FAIRE].KEEP_ACTIVE.SET,
        value: !!preview.getIn([ATTRIBUTE.PREORDER, ATTRIBUTE.KEEP_ACTIVE]),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.PREORDER, ATTRIBUTE.START_DATE])) {
    payload.push(
      Map({
        type: OPERATIONS[FAIRE].START_DATE.SET,
        value: getInventoryOperationValue({
          channel: FAIRE,
          type: ATTRIBUTE.START_DATE,
          value: preview.getIn([ATTRIBUTE.PREORDER, ATTRIBUTE.START_DATE]),
        }),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.PREORDER, ATTRIBUTE.END_DATE])) {
    payload.push(
      Map({
        type: OPERATIONS[FAIRE].END_DATE.SET,
        value: getInventoryOperationValue({
          channel: FAIRE,
          type: ATTRIBUTE.END_DATE,
          value: preview.getIn([ATTRIBUTE.PREORDER, ATTRIBUTE.END_DATE]),
        }),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.PREORDER, ATTRIBUTE.DEADLINE_DATE])) {
    payload.push(
      Map({
        type: OPERATIONS[FAIRE].DEADLINE_DATE.SET,
        value: getInventoryOperationValue({
          channel: FAIRE,
          type: ATTRIBUTE.DEADLINE_DATE,
          value: preview.getIn([ATTRIBUTE.PREORDER, ATTRIBUTE.DEADLINE_DATE]),
        }),
      })
    );
  }

  return { payload };
}
